module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/160Ir6b/tc-custom/9781488096051.jpg?1726519109984",
      "alt": "This image is the cover for the book Hidden in the Everglades, Guardians, Inc."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hidden in the Everglades, Guardians, Inc.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("There’s danger lurking around every corner in this classic book of suspense from the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author of "), _c('i', [_vm._v("Protecting Her Own")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Being a bodyguard is Kyra Morgan’s business. Even though she’s on vacation, she can’t refuse a request from childhood friend and neighbor Michael Hunt. Michael’s sister Amy ran away after witnessing a murder. Michael needs Kyra’s help to find her and keep her safe. Yet as Kyra and Michael follow the trail along the Florida coast, their search grows more dangerous by the day. Terrorists are at work, and the stakes are perilously high. It will take everything they have—including trust they’re both reluctant to give—to escape the Everglades alive . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Margaret Daley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Margaret Daley, an award-winning author of eighty-three books, has been married for over forty years and is a firm believer in romance and love. When she isn’t traveling, she’s writing love stories, often with a suspense thread, and corralling her three cats that think they rule her household. To find out more about Margaret visit her website at http://www.margaretdaley.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0